@import '../../sass/helpers';
@import '../../sass/base/variables';

@mixin transition($name, $duration, $easing) {
  -webkit-transition: $name $duration $easing;
  -moz-transition: $name $duration $easing;
  -o-transition: $name $duration $easing;
  transition: $name $duration $easing;
}

$HEADER_HEIGHT: 4.5rem;
$ACTIONS_HEIGHT: 4rem;

// Used for accessibility
.visually-hidden {
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.visually-hidden:focus {
  clip: auto;
  height: auto;
  overflow: auto;
  position: absolute;
  width: auto;
}

.som-dpm {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  z-index: $datepicker-index;
}

.som-dpm-container {
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -100%;
  background-color: $white;
  display: flex;
  flex-direction: column;

  @include transition(bottom, 0.2s, ease-in-out);
}

.som-dpm-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  height: $HEADER_HEIGHT;

  .som-dpm-close-button-container {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;

    .som-dpm-close-button {
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .som-dpm-input-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-bottom: 0.5rem;

    .som-dpm-input-arrow {
      width: 3.125rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $navy;
    }

    input {
      display: inline-block;
      border-left: 0;
      border-right: 0;
      border-top: 0;
      border-radius: 0;
      padding: 0.5rem;
      width: 8.25rem;
      height: 2rem;
      text-align: center;

      &::placeholder {
        font-size: 0.9rem;
        color: #999;
      }

      &::-ms-clear {
        display: none;
      }
    }
  }
}

.som-dpm-calendar {
  display: flex;
  flex: 1;
  justify-content: center;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  overflow-y: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.som-dpm-actions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
  height: $ACTIONS_HEIGHT;
  background: #fff;
}
